import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActiveGlobalDiscount } from '../slices/activeGlobalDiscountSlice';

const useFetchActiveGlobalDiscount = () => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.userInfo?._id || null);

    useEffect(() => {
        if (!userId) {
            return;
        }

        dispatch(fetchActiveGlobalDiscount());
    }, [dispatch, userId]);
};

export default useFetchActiveGlobalDiscount;
